import { Observable } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { map } from 'rxjs/operators';
import { AppState } from '../../app-state';
import { CONTENT_TYPE_HEADERS, authHeaders } from '../../common/utils/fetch';
import { config } from '../../config/application.config';
import { NazgulPredictionResponse } from '../models/predictions.model';

export type NazgulPredictionRequest = {
  document_set: string;
  target_document_id: number;
  annotation_types?: string[];
};

export const NazgulPredictionResource = {
  getPredictUrl(): string {
    return `${config.nazgul.url}/predict`;
  },

  getHealthUrl(): string {
    return `${config.nazgul.url}/health`;
  },

  predict(
    request: NazgulPredictionRequest,
    state: AppState,
  ): Observable<NazgulPredictionResponse> {
    return ajax({
      url: this.getPredictUrl(),
      method: 'POST',
      headers: {
        ...authHeaders(state),
        ...CONTENT_TYPE_HEADERS.JSON,
      },
      body: request,
      timeout: 25 * 60 * 1000, // 25 minutes
    }).pipe(map(response => response.response as NazgulPredictionResponse));
  },

  healthCheck(): Observable<{ status: string; service: string }> {
    return ajax.getJSON<{ status: string; service: string }>(
      this.getHealthUrl(),
    );
  },
};
